export default __webpack_public_path__ + "static/media/todo-list.59b427bc.png";